import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import datetimeHelper from '../Helpers/datetimeHelper';
import JsxHelper from '../Helpers/JsxHelper';
import React from 'react';

export default class TpEvaluatorSchedulingItem {
  constructor(item) {
    if (item == null) {
      this.ThirdPartyEvaluatorId = 0;
      this.TpEvaluatorId = 0;
      this.ThirdPartySource = '';
      this.FirstName = '';
      this.LastName = '';
      this.Email = '';
      this.PhoneMain = '';
      this.PhoneMobile = '';
      this.AccountStatus = '';
      this.Birthday = '';
      this.City = '';
      this.State = '';
      this.ZipCode = '';
      this.CountryName = '';
      this.LastRating = '';
      this.SignDate = '';
      this.LastLogin = '';
      this.LastShop = '';
      this.AllShopsCountLastNDays = 0;
      this.ExcludedShopsCountLastNDays = 0;
      this.ExcludedPSShopsCountLastNDays = 0;
      this.FinalizedLockedShopsCountLastNDays = 0;
      return;
    }
    this.ThirdPartyEvaluatorId = item.thirdPartyEvaluatorId;
    this.TpEvaluatorId = item.tpEvaluatorId;
    this.ThirdPartySource = item.thirdPartySource;
    this.FirstName = item.firstName;
    this.LastName = item.lastName;
    this.Email = item.email;
    this.PhoneMain = item.phoneMain;
    this.PhoneMobile = item.phoneMobile;
    this.AccountStatus = item.accountStatus;
    this.Birthday = datetimeHelper.toYYYYsMMsDD(item.birthday);
    this.City = item.city;
    this.State = item.state;
    this.ZipCode = item.zipCode;
    this.CountryName = item.countryName;
    this.LastRating = item.lastRating;
    this.SignDate = datetimeHelper.toYYYYsMMsDD(item.signDate);
    this.LastLogin = item.lastLogin;
    this.LastShop = datetimeHelper.toYYYYsMMsDD(item.lastShop);
    this.AllShopsCountLastNDays = item.allShopsCountLastNDays;
    this.ExcludedShopsCountLastNDays = item.excludedShopsCountLastNDays;
    this.ExcludedPSShopsCountLastNDays = item.excludedPSShopsCountLastNDays;
    this.FinalizedLockedShopsCountLastNDays = item.finalizedLockedShopsCountLastNDays;
  }

  static NameOfTheIdField() {
    return 'ThirdPartyEvaluatorId';
  }

  static FieldsToShowInDataTable() {
    return [
      { label: 'Source', orderById: 'ThirdPartySource', data: 'ThirdPartySource', minWidth: '120px' },
      {
        label: 'First Name',
        orderById: 'FirstName',
        data: 'FirstName',
      },
      {
        label: 'Last Name',
        orderById: 'LastName',
        data: 'LastName',
      },
      { label: 'Email', orderById: 'Email', data: (item) => JsxHelper.MailTo(item.Email) },
      {
        label: 'Telephone 1',
        orderById: 'PhoneMain',
        data: 'PhoneMain',
      },
      {
        label: 'Telephone 2',
        orderById: 'PhoneMobile',
        data: 'PhoneMobile',
      },
      { label: 'Account Status', orderById: 'AccountStatus', data: 'AccountStatus', minWidth: '120px' },
      { label: 'DOB', orderById: 'Birthday', data: 'Birthday' },
      { label: 'City', orderById: 'City', data: 'City' },
      { label: 'State', orderById: 'State', data: 'State' },
      { label: 'ZIP', orderById: 'ZipCode', data: 'ZipCode' },
      { label: 'Country', orderById: 'CountryName', data: 'CountryName' },
      { label: 'Rating (Last)', orderById: 'LastRating', data: 'LastRating' },
      { label: 'Signup Date', orderById: 'SignDate', data: 'SignDate' },
      { label: 'Last Login Date', orderById: 'LastLogin', data: 'LastLogin' },
      { label: 'Last Shop Date', orderById: 'LastShop', data: 'LastShop' },
      { label: 'All Shops In n Days #', orderById: 'AllShopsCountLastNDays', data: 'AllShopsCountLastNDays' },
      {
        label: 'Excluded Shops In n Days #',
        orderById: 'ExcludedShopsCountLastNDays',
        data: 'ExcludedShopsCountLastNDays',
        minWidth: 110,
      },
      {
        label: 'Excluded PS In n Days #',
        orderById: 'ExcludedPSShopsCountLastNDays',
        data: 'ExcludedPSShopsCountLastNDays',
        minWidth: 110,
      },
      {
        label: 'Client Delivered Shops In n Days #',
        orderById: 'FinalizedLockedShopsCountLastNDays',
        data: 'FinalizedLockedShopsCountLastNDays',
      },
      {
        label: ' ',
        orderById: '',
        data: TpEvaluatorSchedulingItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        className: 'text-center',
      },
    ];
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-comments',
            text: 'Comments',
            onClick: () => TpEvaluatorSchedulingItem.commentsFunction(item),
          },
        ]}
      />
    );
  }

  static commentsFunction = (item) => {
    alert('Empty function');
  };
}
